import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { withAgentPage, withLayout } from 'hocs'
import compose from 'recompose/compose'
import { useParams } from 'react-router'
import { useStore } from 'store'
import { priceFormat } from 'util/prices'
import { hideLoader, showLoader } from 'store/actions/commons'
import GiftsHeaderCart from 'newComponents/GiftsHeader/GiftsHeaderCart'
import CardTitleEvent from 'newComponents/CardTitleEvent'
import useCartProducts from 'newHooks/useCartProducts'
import { NO_IMAGE_DEFAULT } from 'constants/env'
import styles from './styles.module.sass'



const BuyGiftsNew = () => {
    const [, dispatch] = useStore((state) => state.giftTable.giftTable)
    const { tableId } = useParams()

    const {
        cartID,
        products,
        setListCarts,
        getEventTable,
        responseTable
    } = useCartProducts()

    const [ addProduct, ] = useState(false)
    const [ deleteProduct, setDeleteProduct ] = useState(false)
   
    useEffect(()=>{
        getEventTable(tableId)
        dispatch(showLoader())
    },[])

    useEffect(()=>{
        if(products){
            dispatch(hideLoader())
        }
    },[ products ])


    return(
        <>
            <GiftsHeaderCart
                eventId={tableId}
                products={products}
                addProduct={addProduct}
                deleteProduct={deleteProduct}
                setDeleteProduct={setDeleteProduct}
                setListCarts={setListCarts}
                showModule={false}
            />

            <CardTitleEvent
                responseTable={responseTable}
            />

            <div className={styles?.contentBuy}>
                {responseTable
                    ? 
                        responseTable?.status !== 'Close'
                            ?
                                <>
                                    {products
                                        ?
                                            products?.length >= 1
                                                ?
                                                    <div className={ `${styles?.sectionFilters} containerPortal`}>
                                                        <h1>Confirma tu compra</h1>
                                                    </div>
                                                : null
                                        : null
                                    }

                                    <CartGiftsEvent
                                        tableId={tableId}
                                        cartID={cartID}
                                        setDeleteProduct={setDeleteProduct}
                                        products={products}
                                    />

                                </>
                            : <div className={styles?.noProducts}><div className={styles?.imageNoTables} />¡Muchas gracias! El evento ha terminado</div>
                    : <div className={styles?.emptyDiv} />
                }
            </div>
        </>
    )
}

const CartGiftsEvent = (props) => {
    const {
        tableId,
        cartID,
        setDeleteProduct,
        products
    } = props

    
    const history = useHistory();
    const [ count, setCount ] = useState(1)
    const [ subTotal, setSubTotal ] = useState(0)
    const [ discount, setDiscount ] = useState(0)
    const [ total, setTotal ] = useState(0)
    const [ shipping, ] = useState(0)

    const handleClick = () => {
        const urlToPay = `/payment-flow/${tableId}/steps-flow`
        history.push(urlToPay)
    }
    
    const noGifts = () => {
        const urlToPay = `/invitado/${tableId}`
        history.push(urlToPay)
    }

    const handleRemove = (event) => {
        const cart_id = cartID
        const productID = Number(event.currentTarget.getAttribute('data-productid'))
        const amount = event.currentTarget.getAttribute('data-amount')
        const variation = event.currentTarget.getAttribute('data-variation') || null
        setDeleteProduct({cart_id, productID, variation})
    }

    useEffect(()=>{
        if(products){
            if(products?.length >= 1){
                
                // const artTotales = products?.length
                // const salesPrice  = products.reduce((accumulator, currentValue) => accumulator + currentValue?.pricing?.sales_price, 0);
                // const price  = products.reduce((accumulator, currentValue) => accumulator + currentValue?.pricing?.list_price, 0);
                
                const salesPrice2  = products.reduce((accumulator, currentValue) => accumulator + (currentValue?.pricing?.sales_price * currentValue?.amount), 0);
                const price2  = products.reduce((accumulator, currentValue) => accumulator + (currentValue?.pricing?.list_price * currentValue?.amount), 0);
                const cantTotal  = products.reduce((accumulator, currentValue) => accumulator + currentValue?.amount, 0);
                
                console.log('products: ',products)
                // console.log('price: ',price)
                // console.log('salesPrice: ',salesPrice)
                // console.log('price2: ',price2)
                // console.log('salesPrice2: ',salesPrice2)
                // console.log('cantTotal: ',cantTotal)

                const precioSubT = price2
                const desc = price2 - salesPrice2
                const precioTotal = salesPrice2
                setCount(cantTotal)
                setSubTotal(precioSubT)
                setDiscount(desc)
                setTotal(precioTotal)
            }
            else{
                setCount(0)
                setSubTotal(0)
                setDiscount(0)
                setTotal(0)
            }
        }
    },[products])


    return(

        count >= 1
            ?
                <div className={ `${styles?.contProductsCart} containerPortal`}>
                    <div className={styles?.contResumeProducts}>
                        <h2>Lista de regalos</h2>
                        <div>
                            {products
                                ?
                                    products?.length >= 1
                                        ?
                                            products?.map(producto => {
                                                const image = producto?.pictures ? producto?.pictures[0]?.source.indexOf('?') === -1 ? `${producto?.pictures[0]?.source}?scale=250` :`${producto?.pictures[0]?.source}&scale=250` : NO_IMAGE_DEFAULT
                                                
                                                return(
                                                    <div
                                                        className={styles?.cardProduct} 
                                                        key={producto?.id}
                                                    >
                                                        <img src={image} className={styles?.imageCont} alt={producto?.title} />
                                                        <div className={styles?.contData}>
                                                            <p className={styles?.title}>{producto?.title}</p>
                                                            <p className={styles?.remove}>Cantidad: {producto?.amount}</p>
                                                            <p className={styles?.priceTotal}>${priceFormat(producto?.pricing?.list_price)} MXN</p>
                                                            <div className={styles?.contButons}>
                                                                <div
                                                                    className={styles?.remove} 
                                                                    onClick={handleRemove}
                                                                    data-productid={producto?.id} 
                                                                    data-amount={producto?.amount} 
                                                                    data-variation={producto?.variant_id ? producto?.variant_id : null} 
                                                                    aria-hidden
                                                                >Eliminar</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        : null
                                : null
                            }

                        </div>
                    </div>

                    <div className={styles?.contResumeCart}>
                        <h2>Resumen</h2>
                        <div>
                            <div className={styles?.cardCart}>
                                <dl>
                                    <dt>Subtotal ({count} {count > 1 ? 'articulos' : 'articulo'}):</dt>
                                    <dd>${priceFormat(subTotal)}</dd>
                                </dl>
                                <dl>
                                    <dt>Descuento:</dt>
                                    <dd>${priceFormat(discount)}</dd>
                                </dl>
                                <dl>
                                    <dt>Cupones :</dt>
                                    <dd>${priceFormat(shipping)}</dd>
                                </dl>
                                <dl>
                                    <dt>Costo de envio ({count} {count > 1 ? 'articulos' : 'articulo'}):</dt>
                                    <dd>${priceFormat(shipping)}</dd>
                                </dl>

                                <dl className={styles?.lastTotal}>
                                    <dt><strong>Total</strong> (IVA incluido): </dt>
                                    <dd className={styles?.priceTotal}>${priceFormat(total)} MXN</dd>
                                </dl>

                            </div>
                            <div onClick={handleClick} className="btn primaryButton" aria-hidden>Finalizar compra</div>
                        </div>
                    </div>
                </div>
            :
                count === 0
                    ?
                        <div className={styles?.noProducts}>
                            <div className={styles?.imageNoGifts} />Aún no hay regalos en este evento
                            <div className={`btn primaryButton ${styles?.buttonGifts}`} onClick={noGifts} aria-hidden>Seguir comprando</div>
                        </div>
                    : null
    )
}


export default compose(
    withLayout,
    withAgentPage({ fetchTableInfo: true })
)(BuyGiftsNew);